// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__2CFEA","title":"ClientInsurance_title__13nRU","itemText":"ClientInsurance_itemText__1s9cY"};